import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import changeTrackable, { IChangeTrackable } from './changeTrackable';
import model from './model';

export interface IJobCostWorkArea extends IModel, IChangeTrackable {
	name?: string;
	note?: string;
	sortIndex?: number;
	vendorKey?: string;
}

const workAreaFactory = modelFactory.createFactory<IJobCostWorkArea>('JobCostWorkArea', _.assign({}, model, changeTrackable, {
	name: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	},
	note: {
		setFilters: valueFilters.toString
	},
	sortIndex: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(),
		defaultValue: 0.0
	},
	vendorKey: {
		setFilters: valueFilters.clean
	}
}));

export default workAreaFactory;